import React, { Component } from 'react';
import PortalSettings from '../../../components/shared/portal-settings';
import PortalSettingCheckbox from '../../../components/shared/portal-setting-checkbox';

class PortalSettingsCapsule extends Component {

    render() {

        const portal = this.props.portal || {};
        const groups = [];

        PortalSettings.forEach((setting) => {

            let group = groups.find((g) => g.name === setting.group);
            if (!group) {
                group = { name: setting.group, settings: [] };
                groups.push(group);
            }

            group.settings.push(setting);
        });

        return (
            <div style={{ marginTop: '3%', marginBottom: '3%' }} className="col-12">
                <div className="row">
                    <div className="col-12">
                        <span className="text-left">
                            <strong>Portal Settings</strong>
                        </span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div style={{ paddingLeft: '3%' }}>
                            <small className="form-text text-muted">
                                Applied to this application's SSO pages. Matching query parameters on a link still take effect.
                            </small>
                            {groups.map((group) => (
                                <div key={group.name} style={{ marginTop: '0.75rem' }}>
                                    <em>{group.name}</em>
                                    <div style={{ paddingLeft: '1.25rem' }}>
                                        {group.settings.map((setting) => (
                                            <PortalSettingCheckbox
                                                key={setting.key}
                                                settingKey={setting.key}
                                                label={setting.label}
                                                help={setting.help}
                                                checked={portal[setting.key] === true}
                                                onChange={this.props.onPortalSettingChanged} />
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default PortalSettingsCapsule;
